import { render } from "./good-road-panel.vue?vue&type=template&id=311f4a54&scoped=true&ts=true"
import script from "./good-road-panel.vue?vue&type=script&lang=ts"
export * from "./good-road-panel.vue?vue&type=script&lang=ts"

import "./good-road-panel.vue?vue&type=style&index=0&id=311f4a54&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311f4a54"]])

export default __exports__